import { render } from "./ToggleModalComponent.vue?vue&type=template&id=4a3111cc&ts=true"
import script from "./ToggleModalComponent?vue&type=script&lang=ts"
export * from "./ToggleModalComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__